
import dayjs from 'dayjs'
import Select from './Select'

export default function MonthSelect(props) {
  const nextYear = dayjs().add(1, 'year')
  const prevYear = dayjs().subtract(1, 'year')

  const generateMonthYearOptions = (start, end) => {
    const monthsYears = []
    let current = dayjs(start).startOf('month')

    while (current.isBefore(end)) {
      const date = current.format('YYYY-MM')
      monthsYears.push({ id: date, name: dayjs(date).format('MMMM, YYYY') })
      current = current.add(1, 'month')
    }

    return monthsYears
  }
  const options = generateMonthYearOptions(prevYear, nextYear)

  return <Select options={options} {...props} />
}
